import { render } from "./CampusComparisonChart.vue?vue&type=template&id=335dedcc&scoped=true"
import script from "./CampusComparisonChart.vue?vue&type=script&lang=js"
export * from "./CampusComparisonChart.vue?vue&type=script&lang=js"

import "./CampusComparisonChart.vue?vue&type=style&index=0&id=335dedcc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-335dedcc"

export default script